export default "__VITE_ASSET__b7112652__"